import './Footer.css.proxy.js';
/* src/components/Footer.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	text
} from "../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let footer;
	let div;
	let t0;
	let a0;
	let t1;
	let t2;
	let a1;
	let t3;
	let t4;
	let a2;
	let t5;
	let t6;
	let a3;
	let t7;

	return {
		c() {
			footer = element("footer");
			div = element("div");
			t0 = text("Data from the\n    ");
			a0 = element("a");
			t1 = text("Data is Plural");
			t2 = text("\n    archive, photos are from\n    ");
			a1 = element("a");
			t3 = text("Unsplash");
			t4 = text("\n    , some colors are from\n    ");
			a2 = element("a");
			t5 = text("Color Claim");
			t6 = text("\n  Made with 💗 by\n  ");
			a3 = element("a");
			t7 = text("Amelia Wattenberger");
			this.h();
		},
		l(nodes) {
			footer = claim_element(nodes, "FOOTER", { class: true });
			var footer_nodes = children(footer);
			div = claim_element(footer_nodes, "DIV", {});
			var div_nodes = children(div);
			t0 = claim_text(div_nodes, "Data from the\n    ");
			a0 = claim_element(div_nodes, "A", { href: true });
			var a0_nodes = children(a0);
			t1 = claim_text(a0_nodes, "Data is Plural");
			a0_nodes.forEach(detach);
			t2 = claim_text(div_nodes, "\n    archive, photos are from\n    ");
			a1 = claim_element(div_nodes, "A", { href: true });
			var a1_nodes = children(a1);
			t3 = claim_text(a1_nodes, "Unsplash");
			a1_nodes.forEach(detach);
			t4 = claim_text(div_nodes, "\n    , some colors are from\n    ");
			a2 = claim_element(div_nodes, "A", { href: true });
			var a2_nodes = children(a2);
			t5 = claim_text(a2_nodes, "Color Claim");
			a2_nodes.forEach(detach);
			div_nodes.forEach(detach);
			t6 = claim_text(footer_nodes, "\n  Made with 💗 by\n  ");
			a3 = claim_element(footer_nodes, "A", { href: true });
			var a3_nodes = children(a3);
			t7 = claim_text(a3_nodes, "Amelia Wattenberger");
			a3_nodes.forEach(detach);
			footer_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a0, "href", "https://github.com/data-is-plural/newsletter-archive");
			attr(a1, "href", "");
			attr(a2, "href", "https://vanschneider.com/colors");
			attr(a3, "href", "https://twitter.com/Wattenberger");
			attr(footer, "class", "svelte-1z0omfq");
		},
		m(target, anchor) {
			insert(target, footer, anchor);
			append(footer, div);
			append(div, t0);
			append(div, a0);
			append(a0, t1);
			append(div, t2);
			append(div, a1);
			append(a1, t3);
			append(div, t4);
			append(div, a2);
			append(a2, t5);
			append(footer, t6);
			append(footer, a3);
			append(a3, t7);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(footer);
		}
	};
}

class Footer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Footer;
//# sourceMappingURL=Footer.js.map
